'use client'

import { SplitText } from 'gsap/SplitText'

import { gsap, ScrollTrigger, useGSAP } from '@/core/lib/gsap/register'

/* veluvit 화면 모션 — core GSAP 인스턴스에 SplitText 를 더해 쓴다.
   registerPlugin 은 여러 번 불러도 안전하므로 사용하는 플러그인을 여기서 등록한다. */
if (typeof window !== 'undefined')
  gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP)

/** 화면 전반의 기본 곡선 — 빠르게 들어와 부드럽게 멈춘다 */
export const EASE_OUT = 'power3.out'

export { gsap, SplitText, useGSAP }
